/*
 * dg-carousel-fit.js
 * The theme hardcodes .featured-collection carousel viewport heights
 * (450px desktop / 315px mobile, both !important). With taller product
 * cards (4:5 images, fit-to-image) the card text overflows that box and the
 * viewport's horizontal scrollbar cuts across the price.
 *
 * This measures the tallest slide and applies that height to the viewport,
 * overriding the hardcoded values, so the carousel always fits its content
 * at any width or aspect ratio.
 */
(function () {
  var SEL = '.featured-collection__inner.display-type--carousel .flickity-viewport';

  function fit(viewport) {
    var slider = viewport.querySelector('.flickity-slider');
    if (!slider) return;
    var slides = slider.children;
    var tallest = 0;
    for (var i = 0; i < slides.length; i++) {
      var h = slides[i].getBoundingClientRect().height || slides[i].scrollHeight;
      if (h > tallest) tallest = h;
    }
    if (tallest > 0) {
      viewport.style.setProperty('height', Math.ceil(tallest) + 14 + 'px', 'important');
    }
  }

  function fitAll() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) fit(nodes[i]);
  }

  var timer;
  function fitSoon() {
    clearTimeout(timer);
    timer = setTimeout(fitAll, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitSoon);
  } else {
    fitSoon();
  }
  window.addEventListener('load', fitSoon);
  window.addEventListener('resize', fitSoon);
  // Lazy-loaded card images change slide height after they decode.
  document.addEventListener('lazyloaded', fitSoon, true);
  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') fitSoon();
  }, true);
  // Theme editor re-renders.
  document.addEventListener('shopify:section:load', fitSoon);
  document.addEventListener('shopify:section:select', fitSoon);
})();
